module.exports = __webpack_public_path__ + "static/img/xl4.12f31c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xl4.jpg
// module id = 7tMz
// module chunks = 1